import { CollaboratorEditComponent } from './home/collaborators/collaborator-edit/collaborator-edit.component';
import { SubscriptionRenewComponent } from './settings/subscription-renew/subscription-renew.component';
import { AddPaymentComponent } from './settings/account/add-payment/add-payment.component';
import { BillingEditComponent } from './settings/account/billing-edit/billing-edit.component';
import { ManageComponent } from './settings/account/manage/manage.component';
import { BillingComponent } from './settings/account/billing/billing.component';
import { StatisticsComponent } from './home/statistics/statistics.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MemberComponent } from './member.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SettingsComponent } from './settings/settings.component';
import { ProfileComponent } from './settings/profile/profile.component';
import { ChangePasswordComponent } from './settings/change-password/change-password.component';
import { ProfileEditComponent } from './settings/profile-edit/profile-edit.component';
import { SpacesComponent } from './spaces/spaces.component';
import { EmptyShowcaseComponent } from './spaces/empty-showcase/empty-showcase.component';
import { ShowcaseComponent } from './spaces/showcase/showcase.component';
import { ImagesComponent } from './spaces/images/images.component';
import { MaterialComponent } from './spaces/material/material.component';
import { ResourceComponent } from './spaces/resource/resource.component';
import { FloorplanComponent } from './spaces/floorplan/floorplan.component';
import { EditTwodimensionComponent } from './spaces/showcase/edit-twodimension/edit-twodimension.component';
import { PublicSpaceComponent } from './home/public-space/public-space.component';

import { SubscribeGuard } from './../services/subscribe-guard.service';
import { AuthGuardService } from './../services/auth-guard.service';
import { SubscriptionStatusGuard } from './../services/subscriptionstatus-guard.service';
import { RequestdollhouseGuard } from './../services/requestdollhouse/requestdollhouse-guard.service';

import { CardSubscriptionComponent } from './settings/subscription-renew/card-subscription/card-subscription.component';
import { ConfirmSubscriptionComponent } from './settings/subscription-renew/confirm-subscription/confirm-subscription.component';

import { VideoListComponent } from './spaces/video-list/video-list.component';

// Request dollhouse
import { RequestdollhouseComponent } from './spaces/showcase/requestdollhouse/requestdollhouse.component';
import { UploaddollhouseComponent } from './spaces/showcase/requestdollhouse/uploaddollhouse/uploaddollhouse.component';
import { ConfirmdollhouseComponent } from './spaces/showcase/requestdollhouse/confirmdollhouse/confirmdollhouse.component';
import { StatisticsDetailComponent } from './spaces/statistics-detail/statistics-detail.component';
import { CollaboratorsComponent } from './home/collaborators/collaborators.component';
import { RoleComponent } from './settings/account/role/role.component';
import { CompanyResolverService } from '../services/company-resolver.service';
import { AdminGuard } from '../services/admin-guard.service';


const routes: Routes = [
  {
    path: 'member',
    component: MemberComponent,
    resolve: { company: CompanyResolverService },
    canActivate: [AuthGuardService, SubscriptionStatusGuard, SubscribeGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'collaborators',
        component: CollaboratorsComponent,
        canActivate: [AdminGuard] },
      { path: 'collaborators/:id', component: CollaboratorEditComponent},
      { path: 'public-space', component: PublicSpaceComponent },
      { path: 'statistics', component: StatisticsComponent},
      { path: 'settings',
        component: SettingsComponent,
        children: [
          { path: '', redirectTo: 'profile', pathMatch: 'full' },
          {
            path: 'profile',
            component: ProfileComponent
          },
          {
            path: 'edit',
            component: ProfileEditComponent
          },
          {
            path: 'change/password',
            component: ChangePasswordComponent
          },
          {
            path: 'account/billing',
            component: BillingComponent,
            canActivate: [AdminGuard]
          },
          {
            path: 'account/manage',
            component: ManageComponent,
            canActivate: [AdminGuard]
          },
          {
            path: 'account/roles',
            component: RoleComponent,
            canActivate: [AdminGuard]
          },
          {
            path: 'account/billing/address',
            component: BillingEditComponent,
            canActivate: [AdminGuard]
          },
          {
            path: 'account/billing/add-payment',
            component: AddPaymentComponent,
            canActivate: [AdminGuard]
          },
          {
            path: 'subscription/renew',
            component: SubscriptionRenewComponent,
          },
          {
            path: 'subscription/renew/card',
            component: CardSubscriptionComponent
          },
          {
            path: 'subscription/renew/confirm',
            component: ConfirmSubscriptionComponent
          },
        ]},
      { path: 'spaces/:id/empty-spaces', component: EmptyShowcaseComponent},
      { path: 'spaces/:id',
        component: SpacesComponent,
        children: [
          { path: '', redirectTo: 'showcase', pathMatch: 'full' },
          { path: 'showcase', component: ShowcaseComponent},
          { path: 'showcase/edit', component: EditTwodimensionComponent },
          { path: 'request/dollhouse',
            component: RequestdollhouseComponent,
            children: [
              { path: '', redirectTo: 'upload', pathMatch: 'full' },
              { path: 'upload', component: UploaddollhouseComponent},
              { path: 'card', component: ConfirmdollhouseComponent, canActivate: [RequestdollhouseGuard]},
            ],
            canActivate: [AdminGuard]
          },
          { path: 'images', component: ImagesComponent },
          { path: 'videos', component: VideoListComponent },
          { path: 'floor-plan', component: FloorplanComponent },
          { path: 'statistics-detail', component: StatisticsDetailComponent },
        ]
      },
      { path: '**', component: NotFoundComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: []
})
export class MemberRoutingModule { }
